import React, { useEffect, useState } from 'react';
import { Navigate, useLocation } from 'react-router-dom';

const ProtectedRoute = ({ children }) => {
  const location = useLocation();
  const isAuthenticated = localStorage.getItem('isAuthenticated') === 'true';
  const currentUserStr = localStorage.getItem('currentUser');
  const [isChecking, setIsChecking] = useState(true);
  const [shouldRedirect, setShouldRedirect] = useState(false);
  const [redirectPath, setRedirectPath] = useState(null);

  useEffect(() => {
    const checkRole = async () => {
      if (!isAuthenticated || !currentUserStr) {
        setIsChecking(false);
        return;
      }

      try {
        const currentUser = JSON.parse(currentUserStr);
        console.log('ProtectedRoute: Checking role for user:', currentUser);
        
        // Если это студент и он пытается зайти на страницы преподавателя
        if (currentUser.role === 'student') {
          const path = location.pathname;
          console.log('ProtectedRoute: Student detected, current path:', path);
          
          // Разрешаем доступ к студентским страницам
          if (path.includes('/student-dashboard') || path.includes('/student-invite') || path.includes('/register/')) {
            console.log('ProtectedRoute: Student on student page, allowing access');
            setIsChecking(false);
            return;
          }
          
          // Для всех остальных страниц - редиректим на студентский dashboard
          console.log('ProtectedRoute: Student on teacher page, redirecting to student dashboard');
          const { getStudentByUserId } = await import('../utils/studentsService');
          const student = await getStudentByUserId(currentUser.id);
          
          console.log('ProtectedRoute: Student data from Supabase:', student);
          
          if (student && student.invite_slug) {
            console.log('ProtectedRoute: Redirecting student to:', `/student-dashboard/${student.invite_slug}`);
            setRedirectPath(`/student-dashboard/${student.invite_slug}`);
            setShouldRedirect(true);
          } else {
            console.error('ProtectedRoute: Student not found in database for user:', currentUser.id);
            // Если студент не найден, все равно редиректим на login
            setRedirectPath('/login');
            setShouldRedirect(true);
          }
        } else {
          // Если это преподаватель, проверяем что он не на студентских страницах
          const path = location.pathname;
          if (path.includes('/student-dashboard')) {
            console.log('ProtectedRoute: Teacher on student page, redirecting to home');
            setRedirectPath('/');
            setShouldRedirect(true);
          }
        }
      } catch (error) {
        console.error('Error checking user role:', error);
      } finally {
        setIsChecking(false);
      }
    };

    checkRole();
  }, [isAuthenticated, currentUserStr, location.pathname]);

  if (!isAuthenticated || !currentUserStr) {
    return <Navigate to="/login" replace />;
  }

  if (isChecking) {
    return <div style={{ padding: '20px', textAlign: 'center' }}>Loading...</div>;
  }

  if (shouldRedirect && redirectPath) {
    return <Navigate to={redirectPath} replace />;
  }

  return children;
};

export default ProtectedRoute; 